import $ from 'jquery'
import {Core} from './core'
import 'slick-carousel'
import {Tabs} from "./tabs.js";

export class SingleNewsletter {
  constructor() {
    let containerSelector = '.single-newsletter'
    this.$container = $(containerSelector)

    if (this.$container.length === 0) {
      return
    }

    this.$window = $(window)
    this.$menu = this.$container.find('.single-newsletter-menu')

    this.tabsController = new Tabs()
    this.tabsController.containerSelector = containerSelector

    this.$window.on('resize', this.fixHeightWrapperMenu.bind(this))
    this.$container.find('.single-newsletter-slider').on('click', '.tab', this.handleClickTab.bind(this))

    $(document).ready(this.init.bind(this))
  }

  init() {
    setTimeout(this.handleLoadHashScroll.bind(this), 980)
    setTimeout(this.fixHeightWrapperMenu.bind(this), 1000)
  }

  handleClickTab(e) {
    this.tabsController.handleClickLinkTab(e)

    setTimeout(() => {
      Core.scrollTo(this.$container)
    }, 300)
  }

  handleLoadHashScroll(e) {
    if (window.location.hash != '' && window.location.hash.length) {
      let $tabLink = $(`[data-${this.tabsController.containerData}-link="${window.location.hash.substring(1)}"]`)

      if ($tabLink.length) {
        this.tabsController.deactivateTabs($tabLink)
        this.tabsController.activateTab($tabLink)

        let self = this
        setTimeout(() => {
          Core.scrollTo(this.$container)
          self.gotToSlide($tabLink.closest('.slick-slide').index())
        }, 600)
      }
    }
  }

  gotToSlide(index) {
    if (Core.isBpGreaterThan('md')) {
      if (index > 2) {
        index = index - 2
      }
    }
    let $slider = this.$container.find('.single-newsletter-slider')
    $slider.slick('slickGoTo', Math.ceil(index))
  }

  fixHeightWrapperMenu() {
    setTimeout(this.updateMenuHeight.bind(this), 300)
  }

  updateMenuHeight() {
    let height = this.$container.find('.slick-slide:not(.slick-current)').outerHeight(true)

    let $menuContent = this.$container.find('.single-newsletter-menu-content')
    if ($menuContent.hasClass('js-sticky-middle')) {
      height += Math.max.apply(null, $menuContent.find('.description').map((i, elt) => {
        return elt.scrollHeight;
      }).get());
      height += 16
    }
    this.$menu.css('height', height)
  }
}
